export const checkPermission = (userRoles = [], permissions = []) => {
  if (permissions.length === 0) return true;
  const hasPermission = userRoles.some(({ id }) => permissions.includes(id));
  return hasPermission;
};
